<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="weui-cells__group textarea-cell">
        <div class="weui-cells__title">标题</div>
        <div class="weui-cells">
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="form.main.no_title"
                placeholder="请输入标题"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="weui-cells__group textarea-cell">
        <div class="weui-cells__title">内容</div>
        <div class="weui-cells">
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <vue-html5-editor :content="form.main.no_content" :height="500" :auto-height="false" @change="updateData"></vue-html5-editor>
              <!-- <textarea
                class="weui-textarea"
                placeholder="请输入通知内容"
                rows="8"
                v-model="form.main.no_content"
                maxlength="500"
              ></textarea>
              <div class="weui-textarea-counter">
                <span>{{form.main.no_content?form.main.no_content.length:0}}</span>/500
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="save">提交</a>
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
      >取消</a>
    </div>
  </div>
</template>

<script>
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/oa/notify",
      codeField: "no_code",
      statusField: "no_statuscode",
      caller: "Notify",
      xtype: "oa-notify-formpanel",
      form: {
        main: {
          no_title: "",
          no_content: ""
        }
      }
    };
  },
  methods: {
    save() {
      var me = this,
        main = me.form.main;
      if (!main.no_title) {
        me.$weui.topTips("请填写标题", 2000);
      } else if (!main.no_content) {
        me.$weui.topTips("请填写通知内容", 2000);
      } else {
        me.p_save();
      }
    },
    p_save() {
      const me = this

      me.$loading({
        url: "/api/oa/notify/save?caller=Notify",
        method: "POST",
        jsonData: me.form
      }).then(res => {
        if(res.success) {
          me.$router.back()
        }
      })
    },
    updateData(content) {
      this.form.main.no_content = content
    }
  }
};
</script>